import { Component, OnInit, Output, Input } from '@angular/core';
import { UsersService } from 'app/pages/users/users.service';
import { DriverScheduleService } from '../../driver-schedule.service';
import { EventEmitter } from '@angular/common/src/facade/async';
import { ActivatedRoute } from '@angular/router';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-create-date-range',
  templateUrl: './create-date-range.component.html',
  styleUrls: ['./create-date-range.component.scss']
})
export class CreateDateRangeComponent implements OnInit {

  providers = [];
  selectedProvider = 19;
  @Output() savedSchedule = new EventEmitter<any> ();
  @Input('copiedDate') copiedDate;

  dateRange: any;
  myDatePickerOptions = {
    dateFormat: 'yyyy-mm-dd',
    editableDateRangeField: false
  };

  constructor(
    private userService: UsersService,
    private service: DriverScheduleService,
    private activatedRoute : ActivatedRoute,
    private toastrAlertHelper: ToastrAlertHelper,
    private sweetAlertHelper: SweetAlertHelper,
  ) { }

  ngOnInit() {
    this.getProviders();
    this.activatedRoute.params.subscribe((params: any) => {
      if (params.id) {
        this.selectedProvider = params.id;
      }
    });
  }

  /**
   * this get all providers
   */
  private getProviders() {
    this.userService.getAllProviders().subscribe(
      data => {
        this.providers = data;
      }
    )
  }

  /**
   * this call service to save date range
   */
  saveDateRange(copied = false) {
    if (this.dateRange && this.selectedProvider) {
      if (this.dateRange.formatted) {
        const split = this.dateRange.formatted.split(' - ');
        if (split.length > 1) {
          let data = {
            fromdate: split[0],
            todate: split[1],
            providerid: this.selectedProvider
          }

          if (copied && this.copiedDate) {
            data['copydate'] = this.removeDayText(this.copiedDate);
          }

          this.service.addSchedule(data).subscribe(
            res => {
              this.toastrAlertHelper.success(res.message);
              this.savedSchedule.emit(data);
            },
            error => {
              this.sweetAlertHelper.createCustomAlert({
                title: 'Error!',
                text: error.message,
                type: 'error'
              })
            }
          )
        }
      }
    }
  }


  /**
   * this remove day text to a date
   * @param date date to remove day text
   */
  private removeDayText(date) {
    const split = date.split(' - ');
    return split.length > 1 ? split[1] : '';
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/driver-schedule/components/create-date-range/create-date-range.component.ts